query ContentShowQuery($id: ID!) {
  content(id: $id) {
    id
    title
    description
    type
    processingStatus
    tags {
      id
      title
    }
    preview {
      id
      url(format: MEDIUM)
    }
    verticalPreview {
      id
      url(format: MEDIUM)
    }
    platform {
      id
      title
    }
    publishAt
    accessStartAt
    hideInGeneralLists
    onlyUsers
    ageRestrictions
    video {
      id
      uid
      fileName
      readyToStream
      duration
      transcodingError
    }
    pendingVideo {
      id
      uid
      fileName
    }
    totalViews
    stream {
      id
      status
      liveConnected
      startAt
      finishAt
      lastPublishAt
      lastPublishFinishAt
      enableRecord
      autoPublishRecord
      isChatEnabled
      dvrEnabled
      recordContentId
      cfAccountId
      liveInputId
      lastError {
        code
        message
      }
      pull {
        sourceUrl
        status
        attempt
        maxAttempts
        lastError {
          message
        }
      }
      entrypoint {
        id
        title
      }
    }
    duration
    transcodingError
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
